import {PaymentService} from "@/service/payment";

const state = {};

const getters = {};

const actions = {
    getTransactionHistory() {
        return PaymentService.getTransactionHistory();
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};